import { render, staticRenderFns } from "./courseStudyList.vue?vue&type=template&id=db9165f8&scoped=true"
import script from "./courseStudyList.vue?vue&type=script&lang=js"
export * from "./courseStudyList.vue?vue&type=script&lang=js"
import style0 from "./courseStudyList.vue?vue&type=style&index=0&id=db9165f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9165f8",
  null
  
)

export default component.exports